// ABOUTME: One child of an AppBar group dropdown, navigating on click and honouring the
// ABOUTME: new-tab modifiers a real link would give for free.

import { MenuItem } from '@ds/coolshop';
import { useLocation, useNavigate } from 'react-router-dom';

import { NavCandidate } from '../types';

type NavGroupMenuItemProps = {
    item: NavCandidate;
    onNavigate: () => void;
};

export const NavGroupMenuItem = ({ item, onNavigate }: NavGroupMenuItemProps) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const destination = `/${item.dest}`;

    const openInNewTab = () => {
        onNavigate();
        window.open(destination, '_blank', 'noopener,noreferrer');
    };

    const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
        if (item.disabled) {
            return;
        }

        if (e.ctrlKey || e.metaKey || e.shiftKey) {
            openInNewTab();
            return;
        }

        onNavigate();
        navigate(destination);
    };

    // A menu item is an <li>, so a middle click never reaches onClick.
    const handleMouseDown = (e: React.MouseEvent<HTMLLIElement>) => {
        if (item.disabled || e.button !== 1) {
            return;
        }

        e.preventDefault();
        openInNewTab();
    };

    return (
        <MenuItem
            icon={item.icon}
            disabled={item.disabled}
            selected={pathname.startsWith(destination)}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
        >
            {item.label}
        </MenuItem>
    );
};
